/* tslint:disable */
/* eslint-disable */
/**
 * The Maritime Resource Registry API
 * The Maritime Resource Registry can be used to create and query resources that are identified by an MRN
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { MaritimeResourceDTO } from '../models';
import { PageMaritimeResourceDTO } from '../models';
/**
 * MaritimeResourceControllerApi - axios parameter creator
 * @export
 */
export const MaritimeResourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new resource
         * @param {MaritimeResourceDTO} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResource: async (body: MaritimeResourceDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createResource.');
            }
            const localVarPath = `/resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || (localVarRequestOptions.headers && localVarRequestOptions.headers['Content-Type'] === 'application/json');
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the resource with the given ID
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResourceById: async (resourceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            if (resourceId === null || resourceId === undefined) {
                throw new RequiredError('resourceId','Required parameter resourceId was null or undefined when calling deleteResourceById.');
            }
            const localVarPath = `/resource/id/{resourceId}`
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the resource with the given MRN and version
         * @param {string} mrn 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResourceByMrnAndVersion: async (mrn: string, version: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mrn' is not null or undefined
            if (mrn === null || mrn === undefined) {
                throw new RequiredError('mrn','Required parameter mrn was null or undefined when calling deleteResourceByMrnAndVersion.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling deleteResourceByMrnAndVersion.');
            }
            const localVarPath = `/resource/{mrn}/{version}`
                .replace(`{${"mrn"}}`, encodeURIComponent(String(mrn)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a page of all registered resources. Is only here for testing purposes and will be removed in the future.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaritimeResources: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resource/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a page of all registered resources under the given MRN namespace.
         * @param {string} namespace 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMaritimeResourcesUnderNamespace: async (namespace: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespace' is not null or undefined
            if (namespace === null || namespace === undefined) {
                throw new RequiredError('namespace','Required parameter namespace was null or undefined when calling getAllMaritimeResourcesUnderNamespace.');
            }
            const localVarPath = `/resource/all/{namespace}`
                .replace(`{${"namespace"}}`, encodeURIComponent(String(namespace)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a page of all versions of the resource with the given MRN
         * @param {string} mrn 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResourcesForMrn: async (mrn: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mrn' is not null or undefined
            if (mrn === null || mrn === undefined) {
                throw new RequiredError('mrn','Required parameter mrn was null or undefined when calling getAllResourcesForMrn.');
            }
            const localVarPath = `/resource/{mrn}`
                .replace(`{${"mrn"}}`, encodeURIComponent(String(mrn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest version of the resource with the given MRN
         * @param {string} mrn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestVersionOfResourceByMrn: async (mrn: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mrn' is not null or undefined
            if (mrn === null || mrn === undefined) {
                throw new RequiredError('mrn','Required parameter mrn was null or undefined when calling getLatestVersionOfResourceByMrn.');
            }
            const localVarPath = `/resource/{mrn}/latest`
                .replace(`{${"mrn"}}`, encodeURIComponent(String(mrn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the resource with the given ID
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceById: async (resourceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            if (resourceId === null || resourceId === undefined) {
                throw new RequiredError('resourceId','Required parameter resourceId was null or undefined when calling getResourceById.');
            }
            const localVarPath = `/resource/id/{resourceId}`
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the resource with the given MRN and version
         * @param {string} mrn 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceByMrnAndVersion: async (mrn: string, version: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mrn' is not null or undefined
            if (mrn === null || mrn === undefined) {
                throw new RequiredError('mrn','Required parameter mrn was null or undefined when calling getResourceByMrnAndVersion.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getResourceByMrnAndVersion.');
            }
            const localVarPath = `/resource/{mrn}/{version}`
                .replace(`{${"mrn"}}`, encodeURIComponent(String(mrn)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaritimeResourceControllerApi - functional programming interface
 * @export
 */
export const MaritimeResourceControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new resource
         * @param {MaritimeResourceDTO} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResource(body: MaritimeResourceDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<MaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).createResource(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes the resource with the given ID
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResourceById(resourceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).deleteResourceById(resourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes the resource with the given MRN and version
         * @param {string} mrn 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResourceByMrnAndVersion(mrn: string, version: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).deleteResourceByMrnAndVersion(mrn, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a page of all registered resources. Is only here for testing purposes and will be removed in the future.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMaritimeResources(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PageMaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).getAllMaritimeResources(page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a page of all registered resources under the given MRN namespace.
         * @param {string} namespace 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMaritimeResourcesUnderNamespace(namespace: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PageMaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).getAllMaritimeResourcesUnderNamespace(namespace, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns a page of all versions of the resource with the given MRN
         * @param {string} mrn 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllResourcesForMrn(mrn: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PageMaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).getAllResourcesForMrn(mrn, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the latest version of the resource with the given MRN
         * @param {string} mrn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestVersionOfResourceByMrn(mrn: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<MaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).getLatestVersionOfResourceByMrn(mrn, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the resource with the given ID
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourceById(resourceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<MaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).getResourceById(resourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns the resource with the given MRN and version
         * @param {string} mrn 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourceByMrnAndVersion(mrn: string, version: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<MaritimeResourceDTO>>> {
            const localVarAxiosArgs = await MaritimeResourceControllerApiAxiosParamCreator(configuration).getResourceByMrnAndVersion(mrn, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MaritimeResourceControllerApi - factory interface
 * @export
 */
export const MaritimeResourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Creates a new resource
         * @param {MaritimeResourceDTO} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResource(body: MaritimeResourceDTO, options?: AxiosRequestConfig): Promise<AxiosResponse<MaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).createResource(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the resource with the given ID
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResourceById(resourceId: number, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return MaritimeResourceControllerApiFp(configuration).deleteResourceById(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the resource with the given MRN and version
         * @param {string} mrn 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResourceByMrnAndVersion(mrn: string, version: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return MaritimeResourceControllerApiFp(configuration).deleteResourceByMrnAndVersion(mrn, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a page of all registered resources. Is only here for testing purposes and will be removed in the future.
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMaritimeResources(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<AxiosResponse<PageMaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).getAllMaritimeResources(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a page of all registered resources under the given MRN namespace.
         * @param {string} namespace 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMaritimeResourcesUnderNamespace(namespace: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<AxiosResponse<PageMaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).getAllMaritimeResourcesUnderNamespace(namespace, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a page of all versions of the resource with the given MRN
         * @param {string} mrn 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllResourcesForMrn(mrn: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<AxiosResponse<PageMaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).getAllResourcesForMrn(mrn, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest version of the resource with the given MRN
         * @param {string} mrn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestVersionOfResourceByMrn(mrn: string, options?: AxiosRequestConfig): Promise<AxiosResponse<MaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).getLatestVersionOfResourceByMrn(mrn, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the resource with the given ID
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourceById(resourceId: number, options?: AxiosRequestConfig): Promise<AxiosResponse<MaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).getResourceById(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the resource with the given MRN and version
         * @param {string} mrn 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResourceByMrnAndVersion(mrn: string, version: string, options?: AxiosRequestConfig): Promise<AxiosResponse<MaritimeResourceDTO>> {
            return MaritimeResourceControllerApiFp(configuration).getResourceByMrnAndVersion(mrn, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaritimeResourceControllerApi - object-oriented interface
 * @export
 * @class MaritimeResourceControllerApi
 * @extends {BaseAPI}
 */
export class MaritimeResourceControllerApi extends BaseAPI {
    /**
     * Creates a new resource
     * @param {MaritimeResourceDTO} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async createResource(body: MaritimeResourceDTO, options?: AxiosRequestConfig) : Promise<AxiosResponse<MaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).createResource(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the resource with the given ID
     * @param {number} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async deleteResourceById(resourceId: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return MaritimeResourceControllerApiFp(this.configuration).deleteResourceById(resourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the resource with the given MRN and version
     * @param {string} mrn 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async deleteResourceByMrnAndVersion(mrn: string, version: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return MaritimeResourceControllerApiFp(this.configuration).deleteResourceByMrnAndVersion(mrn, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a page of all registered resources. Is only here for testing purposes and will be removed in the future.
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async getAllMaritimeResources(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) : Promise<AxiosResponse<PageMaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).getAllMaritimeResources(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a page of all registered resources under the given MRN namespace.
     * @param {string} namespace 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async getAllMaritimeResourcesUnderNamespace(namespace: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) : Promise<AxiosResponse<PageMaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).getAllMaritimeResourcesUnderNamespace(namespace, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a page of all versions of the resource with the given MRN
     * @param {string} mrn 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async getAllResourcesForMrn(mrn: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) : Promise<AxiosResponse<PageMaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).getAllResourcesForMrn(mrn, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the latest version of the resource with the given MRN
     * @param {string} mrn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async getLatestVersionOfResourceByMrn(mrn: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<MaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).getLatestVersionOfResourceByMrn(mrn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the resource with the given ID
     * @param {number} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async getResourceById(resourceId: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<MaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).getResourceById(resourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the resource with the given MRN and version
     * @param {string} mrn 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaritimeResourceControllerApi
     */
    public async getResourceByMrnAndVersion(mrn: string, version: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<MaritimeResourceDTO>> {
        return MaritimeResourceControllerApiFp(this.configuration).getResourceByMrnAndVersion(mrn, version, options).then((request) => request(this.axios, this.basePath));
    }
}
